module.exports = __webpack_public_path__ + "static/media/8. Colgante M1, Superficie sólida, 85 x 60 x 20cm, 2020 copy.bb05d52f.png";